module.exports = __webpack_public_path__ + "img/Under 21 Icon - charcoal.2379c457.svg";